import DateInput from './DateInput.vue'
export default {
  install: function(Vue){
    Vue.component('DateInput',DateInput)
  }
}